import React, { useEffect, useRef } from 'react';
import { Star } from 'lucide-react';
import gsap from 'gsap';
import { getCharactersData } from '../logic/charactersLogic';
import HUD from './HUD';
import BottomNav from './BottomNav';
import iconMap from '../iconMap';
import { ELEMENTS } from '../data';
import { ASSETS } from '../assetManifest';

function Characters({ app }) {
  const gridRef = useRef(null);
  const characters = getCharactersData();

  useEffect(() => {
    gsap.from(gridRef.current.children, {
      y: 50,
      opacity: 0,
      duration: 0.3,
      stagger: 0.05,
      ease: "back.out(1.2)"
    });
  }, []);

  return (
    <div className="bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#1a1a2e] h-full w-full mx-auto relative overflow-hidden text-white">
      <div className="absolute inset-0 bg-[url('/assets/backgrounds/background.png')] opacity-5 bg-cover bg-center" />
      
      <div className="p-6 flex flex-col h-full relative z-10">
        <div ref={gridRef} className="grid grid-cols-3 gap-2 overflow-y-auto hide-scrollbar pb-24">
          {characters.map((character) => (
            <div 
              key={character.id}
              onClick={() => app.goToCharacter(character.id)}
              className="relative h-48 rounded-lg overflow-hidden border border-gray-700/50 backdrop-blur-sm cursor-pointer hover:border-blue-500/50 transition-colors shadow-lg shadow-black/50"
            >
              <img
                src={character.portrait}
                alt={character.name}
                className="absolute inset-0 w-full h-full object-cover object-top transform origin-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
              
              <div className="absolute bottom-0 left-0 right-0 p-2">
                <div className="flex gap-0.5 mb-1">
                  {[...Array(character.stars)].map((_, i) => (
                    <Star key={i} size={14} fill="currentColor" className="text-yellow-400" />
                  ))}
                </div>
                <h3 className="text-sm font-bold truncate" style={{ fontFamily: 'Norse' }}>
                  {character.name}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="text-sm text-gray-400">
                    {character.maxLevel ? `Lv. ${character.level}/${character.maxLevel}` : `Lv. ${character.level}`}
                  </div>
                  <div className="flex gap-1">
                    {character.elements.map((element, index) => {
                      const ElementIcon = iconMap[element];
                      return (
                        <ElementIcon key={index} size={16} className={ELEMENTS[element].color} />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Characters;
